/** Smallest list height before the dropdown flips above the cell (px). */
export const DROPDOWN_MIN = 120;
/** Upper limit of the list height (px). */
export const DROPDOWN_MAX = 320;
const GAP = 2;
const MARGIN = 8;

export interface DropdownPlacement {
  position: 'fixed';
  left: number;
  top?: number;
  bottom?: number;
  minWidth: number;
  maxHeight: number;
}

/**
 * Where a cell's suggestion list goes: below the cell, or above it when there is not enough room
 * below (lists pane at the bottom of the screen); its height fits the room so it scrolls itself.
 */
export function dropdownPlacement(
  cell: { left: number; top: number; bottom: number; width: number },
  viewportHeight: number,
): DropdownPlacement {
  const below = viewportHeight - cell.bottom - GAP - MARGIN;
  const above = cell.top - GAP - MARGIN;
  const base = { position: 'fixed' as const, left: cell.left, minWidth: Math.max(cell.width, 180) };
  if (below >= DROPDOWN_MIN || below >= above)
    return {
      ...base,
      top: cell.bottom + GAP,
      maxHeight: Math.max(0, Math.min(DROPDOWN_MAX, below)),
    };
  return {
    ...base,
    bottom: viewportHeight - cell.top + GAP,
    maxHeight: Math.max(0, Math.min(DROPDOWN_MAX, above)),
  };
}
